import React from "react";
import { Check, X } from "lucide-react";
import { PASSWORD_REQUIREMENTS } from "../utils/passwordPolicy";

interface Props {
  password: string;
}

export const PasswordRequirementsChecklist: React.FC<Props> = ({
  password,
}) => {
  if (!password) return null;

  return (
    <ul className="mt-2 space-y-1.5 text-xs" aria-live="polite">
      {PASSWORD_REQUIREMENTS.map((req) => {
        const ok = req.test(password);
        return (
          <li
            key={req.id}
            className={`flex items-center gap-2 ${
              ok ? "text-teal-300" : "text-white/50"
            }`}
          >
            {ok ? (
              <Check className="h-3.5 w-3.5 flex-shrink-0" aria-hidden />
            ) : (
              <X className="h-3.5 w-3.5 flex-shrink-0" aria-hidden />
            )}
            <span>{req.label}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordRequirementsChecklist;
